import React, {useState} from "react";
import {Button} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {PaginatedRequest} from "../../../models/requests/paginated-request/paginated.request";
import {Export} from "../../core/commons/export/export";
import {useTranslation} from "react-i18next";

interface DownloadResultProps {
    request: PaginatedRequest;
}

export const DownloadResult: React.FC<DownloadResultProps> = ({request}) => {

    const [modalShown, setModalShown] = useState<boolean>(false);
    const {t} = useTranslation("translation", {useSuspense: false});

    return (
        <>
            <Button
                icon={<FontAwesomeIcon icon={["fas", "download"]} size={"sm"} />}
                type={"dashed"}
                size={"small"}
                onClick={() => setModalShown(true)}
            >
                &nbsp;{t("CATALOG.DOWNLOAD_SEARCH_RESULT")}
            </Button>
            {modalShown ? (
                <Export
                    title={"CATALOG.DOWNLOAD_SEARCH_RESULT"}
                    isShown={true}
                    withBasicExportFields
                    config={{
                        link: "/api/v3/articles/search",
                        query: request.toFilters()
                    }}
                    onClose={() => setModalShown(false)}
                />
                ) : null}
        </>
    )
}